import type { WizardField } from './types';

/**
 * 優先順位:
 *   必須   → customer_name
 *   準必須 → phone, email
 *   その他 → NOC, CDW, pax, シート, 便名, comment
 *
 * 超必須（pickup/return/vehicle_type）は Gemini チャットで先に揃えるため、ウィザードには含まない。
 */
export const RESERVATION_WIZARD_FIELDS: WizardField[] = [
  // 必須
  { key: 'customer_name', question: '予約者名を教えてください', inputType: 'text', placeholder: '例: 田中 太郎', required: true },
  // 準必須（連絡先）
  { key: 'phone', question: '電話番号を教えてください', inputType: 'text', placeholder: '例: 090-0000-0000', skipLabel: '不明' },
  { key: 'email', question: 'メールアドレスを教えてください', inputType: 'text', placeholder: '例: example@example.com', skipLabel: '不明' },
  // 補償
  { key: 'noc_waiver', question: 'NOC免責はつけますか？', inputType: 'yes_no' },
  { key: 'cdw', question: 'CDW（車両損害補償）はつけますか？', inputType: 'yes_no' },
  // 乗車人数・シート
  { key: 'pax', question: '乗車人数（大人）は何名ですか？', inputType: 'number', placeholder: '例: 4' },
  { key: 'pax_children', question: '子供の人数は何名ですか？（0=なし）', inputType: 'number' },
  { key: 'child_seat', question: 'チャイルドシートの必要数は？（0=なし）', inputType: 'number' },
  { key: 'booster_seat', question: 'ブースターシートの必要数は？（0=なし）', inputType: 'number' },
  // 便名
  { key: 'arrival_flight', question: '到着便名はありますか？', inputType: 'text', placeholder: '例: NH123', skipLabel: 'なし' },
  { key: 'departure_flight', question: '出発便名はありますか？', inputType: 'text', placeholder: '例: JL987', skipLabel: 'なし' },
  // 要望
  { key: 'comment', question: 'お客様の要望・ご希望はありますか？', inputType: 'text', placeholder: '例: 後部座席を広くしたい' },
];

export function formatWizardAnswer(field: WizardField, value: any): string {
  if (value === null || value === undefined || value === '') return '（スキップ）';
  if (field.inputType === 'yes_no') return value === true ? 'はい' : 'いいえ';
  if (field.inputType === 'number') return `${value}`;
  return String(value);
}
